import { Typography } from '@remarkable/ark-web';

export const DashboardNumber = ({
  value,
  label,
  dataCy = 'dashboard-number',
}: {
  value: string | number;
  label: string;
  dataCy?: string;
}) => (
  <div
    data-cy={dataCy}
    className="flex flex-1 flex-col items-start justify-center p-16 text-left lm:py-16"
  >
    <Typography
      variant="interface-sm"
      leadingNone
      className="font-[300]"
      as="label"
      htmlFor={label}
    >
      {label}
    </Typography>
    <span
      data-cy="value"
      className="body-lg font-bold ls:body-2xl ls:font-bold"
      id={label}
    >
      {value}
    </span>
  </div>
);
